export const STORAGE_KEYS = {
  TOKEN: 'token',
  ACCESS_TOKEN: 'access_token',
  GLOBAL_DATA: 'globalData',
  AUTHORIZED: 'Authorized',
  AMOUNT: 'amount',
  SHARED_USER: 'sharedUserData',
};

export type StorageKey = keyof typeof STORAGE_KEYS;
